module.exports = "/images/vr.37a41b8c820adad9b76627269e4fd296.svg";